import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../components/loading';
import * as api from '../service/api'

function RegisterFreeAccount() {

    const history = useHistory()

    const [step, setStep] = useState('cpf') // 'cpf' | 'contato' | 'codigo'
    const [cpf, setCPF] = useState("")
    const [contatoParaEnvio, setContatoParaEnvio] = useState(null)
    const [contatosWhatsApp, setContatosWhatsApp] = useState([])
    const [contatosEmail, setContatosEmail] = useState([])
    const [contatosSMS, setContatosSMS] = useState([])
    const [erroCPF, setErroCPF] = useState(null)
    const [codigo, setCodigo] = useState("")
    const [feedback, setFeedback] = useState(null)
    const [loading, setLoading] = useState(false)

    const border = <hr className="border-orange-700 my-2" />

    const getFeedback = (tipo, msg) => {
        switch (tipo) {
            case 'success':
                return (
                    <div className="w-full bg-green-600 bg-opacity-20 border border-green-600 rounded-lg relative p-3 mb-4">
                        <button className="absolute top-2 right-3 text-green-400 hover:text-white text-lg" type="button" onClick={() => { setFeedback(null) }}>
                            <span>&times;</span>
                        </button>
                        <span className="text-green-400 text-sm">{msg}</span>
                    </div>
                )
            case 'error':
                return (
                    <div className="w-full bg-red-600 bg-opacity-20 border border-red-600 rounded-lg relative p-3 mb-4">
                        <button className="absolute top-2 right-3 text-red-400 hover:text-white text-lg" type="button" onClick={() => { setFeedback(null) }}>
                            <span>&times;</span>
                        </button>
                        <span className="text-red-400 text-sm">{msg}</span>
                    </div>
                )
        }
    }

    const verificarCPF = () => {
        let cpfNumbers = cpf.replace(/\D/g, "")
        if (cpfNumbers.length != 11) {
            setErroCPF("Campo obrigatório")
            return
        }

        setLoading(true)
        api.verificarCPF(cpfNumbers).then(res => {
            setLoading(false)
            if (!res.success) {
                setFeedback(getFeedback('error', res.message))
                return
            }
            setFeedback(null)
            setContatosWhatsApp(res.contatos_whatsapp)
            setContatosEmail(res.contatos_email)
            setContatosSMS(res.contatos_sms)
            setStep('contato')
        }).catch(e => {
            setLoading(false)
            setFeedback(getFeedback('error', "Algo deu errado"))
            console.error(e)
        })
    }

    const enviarCodigo = () => {
        if (contatoParaEnvio == null) {
            setFeedback(getFeedback('error', "Escolha uma opção"))
            return
        }

        setLoading(true)
        api.enviarCodigoRegistro({ contato_id: contatoParaEnvio.contato.id, tipo: contatoParaEnvio.tipo })
            .then(res => {
                setLoading(false)
                if (!res.success) {
                    setFeedback(getFeedback('error', res.message))
                    return
                }
                setFeedback(null)
                setStep('codigo')
            })
            .catch(e => {
                setLoading(false)
                setFeedback(getFeedback('error', "Algo deu errado"))
                console.error(e)
            })
    }

    const verificarCodigo = () => {
        if (!codigo.trim()) {
            setFeedback(getFeedback('error', "Informe o código"))
            return
        }

        setLoading(true)
        api.verificarCodigoEAtivarTV({ codigo })
            .then(res => {
                setLoading(false)
                if (!res.success) {
                    setFeedback(getFeedback('error', res.message))
                    return
                }
                setFeedback(getFeedback('success', "Sua conta foi ativada! Acesse com seu CPF e senha da Júpiter Internet."))
                setTimeout(() => { history.replace('/') }, 4000)
            })
            .catch(e => {
                setLoading(false)
                setFeedback(getFeedback('error', "Algo deu errado"))
                console.error(e)
            })
    }

    const codigoRender = () => (
        <div className="flex flex-col gap-4">
            <div>
                <h2 className="text-xl font-semibold">Código de verificação</h2>
                <p className="text-sm text-gray-400 mt-1">Informe o código que você recebeu para ativar o acesso aos canais.</p>
            </div>
            {border}
            {feedback}
            <div className="bg-gray-800 border border-gray-700 rounded-lg p-5 flex flex-col gap-4">
                <div className="flex flex-col gap-1">
                    <label className="text-sm text-gray-400">Código</label>
                    <input
                        className="p-2 rounded text-black uppercase tracking-widest text-center text-lg font-mono w-40"
                        maxLength={6}
                        value={codigo}
                        autoComplete="off"
                        onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                    />
                </div>
                <div className="flex justify-between">
                    <button type="button" className="bg-gray-700 hover:bg-gray-600 px-5 py-2 rounded text-white" onClick={() => { setStep('contato'); setFeedback(null) }}>Voltar</button>
                    <button type="button" className="bg-orange-600 hover:bg-orange-700 px-5 py-2 rounded font-semibold text-white" onClick={verificarCodigo}>Verificar</button>
                </div>
            </div>
        </div>
    )

    const RadioOption = ({ id, tipo, contato, label }) => (
        <label
            key={id}
            className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${contatoParaEnvio?.contato?.id === contato.id && contatoParaEnvio?.tipo === tipo
                    ? 'border-orange-500 bg-orange-600 bg-opacity-10'
                    : 'border-gray-700 hover:border-gray-500'
                }`}
            onClick={() => setContatoParaEnvio({ tipo, contato })}
        >
            <input className='w-4 h-4 accent-orange-500' type="radio" checked={contatoParaEnvio?.contato?.id === contato.id && contatoParaEnvio?.tipo === tipo} onChange={() => setContatoParaEnvio({ tipo, contato })} />
            <span className="text-sm font-medium">{contato['contato']}</span>
            <span className="ml-auto text-xs text-gray-500">{label}</span>
        </label>
    )

    const contatoRender = () => (
        <div className="flex flex-col gap-4">
            <div>
                <h2 className="text-xl font-semibold">Como deseja receber o código?</h2>
                <p className="text-sm text-gray-400 mt-1">Escolha onde enviaremos o código de verificação.</p>
            </div>
            {border}
            {feedback}
            <div className="bg-gray-800 border border-gray-700 rounded-lg p-5 flex flex-col gap-3">
                {contatosEmail.map(contato => (
                    <RadioOption key={`email-${contato.id}`} id={`email-${contato.id}`} tipo="email" contato={contato} label="E-mail" />
                ))}
                {contatosSMS.map(contato => (
                    <RadioOption key={`sms-${contato.id}`} id={`sms-${contato.id}`} tipo="sms" contato={contato} label="SMS" />
                ))}
                {contatosWhatsApp.map(contato => (
                    <RadioOption key={`whatsapp-${contato.id}`} id={`whatsapp-${contato.id}`} tipo="whatsapp" contato={contato} label="WhatsApp" />
                ))}
            </div>
            <div className="flex justify-between">
                <button type="button" className="bg-gray-700 hover:bg-gray-600 px-5 py-2 rounded text-white" onClick={() => { setStep('cpf'); setFeedback(null) }}>Cancelar</button>
                <button type="submit" className="bg-orange-600 hover:bg-orange-700 px-5 py-2 rounded font-semibold text-white disabled:opacity-40" disabled={contatoParaEnvio == null} onClick={enviarCodigo}>Enviar código</button>
            </div>
        </div>
    )

    const formCPFRender = () => (
        <div className="flex flex-col gap-4">
            <div>
                <h2 className="text-xl font-semibold">Registrar conta gratuita</h2>
                <p className="text-sm text-gray-400 mt-1">Acesse os canais abertos da Júpiter TV sem custo adicional.</p>
            </div>
            {border}
            {feedback}
            <div className="bg-gray-800 border border-gray-700 rounded-lg p-5 flex flex-col gap-4">
                <div className="flex flex-col gap-1">
                    <label className="text-sm text-gray-400">CPF</label>
                    <InputMask
                        mask="999.999.999-99"
                        className="p-2 rounded text-black w-full"
                        required
                        value={cpf}
                        type="tel"
                        name="cpf"
                        autoComplete="off"
                        placeholder="000.000.000-00"
                        onChange={(e) => { setCPF(e.target.value) }} />
                    {erroCPF && <p className="text-red-500 text-sm">{erroCPF}</p>}
                </div>
                <div className="flex justify-between">
                    <Link to="/"><button type="button" className="bg-gray-700 hover:bg-gray-600 px-5 py-2 rounded text-white">Cancelar</button></Link>
                    <button onClick={verificarCPF} type="submit" className="bg-orange-600 hover:bg-orange-700 px-5 py-2 rounded font-semibold text-white">Verificar CPF</button>
                </div>
            </div>
            <div className="bg-gray-800 border border-gray-700 rounded-lg p-4">
                <p className="text-xs text-gray-400 leading-relaxed">
                    A liberação dos canais do pacote <span className="text-white font-medium">Livres e Abertos</span> está disponível para clientes com planos a partir de <span className="text-white font-medium">R$ 99,90</span>.
                </p>
            </div>
        </div>
    )

    const renderStep = () => {
        switch (step) {
            case 'contato': return contatoRender()
            case 'codigo': return codigoRender()
            default: return formCPFRender()
        }
    }

    return (
        <div className="pt-16 px-5 pb-16">
            <div className="flex flex-col w-full max-w-sm mx-auto">
                <img src={process.env.PUBLIC_URL + 'imagens/logo_jupitertv.svg'} className="mb-6 mx-auto" alt="logo" width="180px" />
                {loading ? <Loading /> : renderStep()}
            </div>
        </div>
    )
}

export default RegisterFreeAccount;
